class Dropdown {
    private menu: HTMLElement;
    private items: NodeListOf<HTMLElement> | undefined;

    constructor(private dropdown: HTMLElement, private button: HTMLElement) {
        this.menu = this.dropdown?.querySelector('.dropdown-inner .menu-wrapper .menu')!;
        this.items = this.dropdown?.querySelectorAll<HTMLElement>('.dropdown-inner .menu-wrapper .menu > .menu-item.menu-item-has-children');

        this.button?.addEventListener('click', () => {
            this.dropdown.classList.contains('show') ? this.close() : this.open();
        });

        this.toggleItems();
    }

    close() {
        const icon = this.button.querySelector('i');
        this.resetItems();
        this.dropdown.classList.remove('show');
        icon?.classList.remove('fa-xmark');
        icon?.classList.add('fa-bars');
    }

    open() {
        const icon = this.button.querySelector('i');
        this.dropdown.classList.add('show');
        icon?.classList.remove('fa-bars');
        icon?.classList.add('fa-xmark');
    }

    private toggleItems() {
        const resetButton = this.dropdown.querySelector<HTMLElement>('.btn-back_to_menu');

        this.items?.forEach(item => {
            const link = item.querySelector<HTMLElement>(':scope > a');
            const submenu = item.querySelector<HTMLElement>(':scope > .sub-menu-wrapper');

            if (!link || !submenu) return;

            item.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;

                if (target !== link && target.closest('a')) return;

                e.preventDefault();
                const isOpen = item.classList.contains('open');

                this.items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove('open');
                    const sm = i.querySelector<HTMLElement>(':scope > .sub-menu-wrapper');
                    if (sm) sm.style.maxHeight = '0px';
                });

                if (!isOpen) {
                    item.classList.add('open');
                    submenu.style.maxHeight = `${submenu.scrollHeight}px`;
                } else {
                    item.classList.remove('open');
                    submenu.style.maxHeight = '0px';
                }
            });
        });

        resetButton?.addEventListener('click', () => {
            this.resetItems();
        });
    }

    private resetItems() {
        this.items?.forEach(item => {
            item.classList.remove('open');
        })
    }
}

window.addEventListener('load', () => {
    const toggle = document.querySelector<HTMLElement>('.dropdown-toggle');
    const dropdown = document.querySelector<HTMLElement>('.dropdown');

    if (!toggle || !dropdown) return;

    new Dropdown(dropdown, toggle);
})